/**
 * Registers the 'sidebarStatusmap' directive with the provided module.
 * This directive is used to include the sidebar status map component in the application.
 * 
 * @param {object} module - The AngularJS module to which the directive will be registered.
 */
export default function registerSidebarStatusmapDirective(module) {
    module.directive('sidebarStatusmap', function() {
        return {
            restrict: 'E', // Restricts the directive to be used as an element only.
            replace: false, // The directive will not replace the original element.
            templateUrl: '/views/ib/modules/sidebar/SidebarStatusmap.html', // Path to the template used by the directive.
            controller: 'SidebarController' // The controller that will handle the logic for this directive.
        };
    });
}